__turbopack_context__.v({
  "background-wave": "bDkJdq_background-wave",
  "path": "bDkJdq_path",
});
